import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { appValidator } from "../Validation";

export const customErrorMessages = {
    required: "Please enter a 5-digit ZIP code",
    regex: "Please enter a 5-digit ZIP code"
};

//export const allFieldsValidation = (data) => {
//    return allFieldsValidationCommon(data, rules, customErrorMessages);
//};

export const allFieldsValidation = (data) =>
{
    var rules = {
        zipCode: ['required', 'regex:/^\\d{5}$/', 'invalid_zip'],
        postData: ['quote_post_data']
    };

    return appValidator.validate({ zipCode: data.zipCode }, rules, customErrorMessages);
};